module.exports = __webpack_public_path__ + "static/Kawika-Patrick-Shaka.66c116ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/SongModal/Kawika-Patrick-Shaka.jpg
// module id = 486
// module chunks = 35783957827783